import { createGlobalStyle } from 'styled-components'
import variables from './variables'

// This is needed to solve this issue https://github.com/facebook/react/issues/2977
const BASE_FONT_SIZE_IN_PX = 17
const BROWSER_DEFAULT_FONT_SIZE_IN_PX = 16

export const GlobalStyle = createGlobalStyle`
  html, body, #___gatsby, #___gatsby > div {
    width: 100%;
  }

  body {
    scroll-behavior: smooth;
  }

  /*
  noscript tag is coming from gatsby's default html template
  https://www.gatsbyjs.org/docs/custom-html/
  */
  noscript {
    position: absolute;
    top: 10px;
    right: 20px;
    font-size: 0.8rem;
    color: #777;
  }

  /* Remove paddings and margins from container elements for predictable layouting */
  html, body, div, section {
    margin: 0;
    padding: 0;
  }

  /* Reset margins before applying new ones to them */
  h1, h2, h3, h4, h5, h6,
  hgroup,
  ul, ol, dl, dd, li > ol, li > ul,
  p,
  figure,
  pre,
  table,
  fieldset,
  blockquote,
  form,
  noscript,
  iframe,
  hr,
  address {
    margin: 0;
    padding: 0;
  }

  hgroup,
  ul,
  ol,
  dl,
  dd,
  p,
  figure,
  pre,
  table,
  fieldset,
  blockquote,
  form,
  noscript,
  iframe,
  address {
    margin-bottom: 1.16rem;
  }

  /* https://www.paulirish.com/2012/box-sizing-border-box-ftw/ */
  html {
    box-sizing: border-box;
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }

  a, a:visited {
    /* Variation of silver tree medium, but having better contrast on white background */
    color: #4ebb93;
    text-decoration: none;
  }

  a:hover,
  a:focus,
  a:active {
    text-decoration: underline;
  }

  ::selection {
    background: #FFAD9D;
    color: white;
  }

  .nowrap {
    white-space: nowrap;
  }

  table {
    width: 100%;
    margin: 30px 0;
    overflow-x: auto;
    display: block;
    text-align: left;
    line-height: 1.45rem;
    border-collapse: collapse;
  }
  th {
    border-bottom: 1px solid #eee;
    font-weight: 600;
    color: #777;
    background-color: #f9f9f9;
    border-radius: 2px;
  }
  th {
    padding: 16px 30px;
  }
  td {
    padding: 16px 30px;
  }
  tr {
    border-bottom: 1px solid #e8e8e8;
  }

  hr {
    margin: 2rem 0;
  }

  /* https://github.com/mrmrs/fluidity */
  img,
  canvas,
  iframe,
  video,
  svg,
  select,
  textarea {
    max-width: 100%;
  }

  blockquote {
    margin: 0;
    border-left: 5px solid #7a7a7a;
    font-style: italic;
    padding: 20px;
  }

  /* Taken from Typography.js generated CSS */
  :root, html {
    font-size: ${BASE_FONT_SIZE_IN_PX / BROWSER_DEFAULT_FONT_SIZE_IN_PX * 100}%;
    line-height: 1.45;
    overflow-y: scroll;
  }

  body {
    color: hsla(0, 0%, 0%, 0.8);
    font-family: 'Source Sans Pro', 'Arial', sans-serif;
    font-weight: 400;
    word-wrap: break-word;
    font-kerning: normal;
    color: #666;
  }

  p {
    max-width: 700px;
  }

  img {
    max-width: 100%;
    margin-bottom: 1.16rem;
  }

  h1, h2, h3, h4, h5, h6 {
    margin-top: 2.175rem;
    margin-bottom: 0.725rem;
    color: hsla(0, 0%, 0%, 0.8);
    font-family: 'Source Sans Pro', 'Arial', sans-serif;
    font-weight: 700;
    text-rendering: optimizeLegibility;
    line-height: 1.2;
  }

  h1 {
    font-size: 2.3rem;
  }

  h2 {
    font-size: 1.8rem;
  }

  h3 {
    font-size: 1.2;
  }

  h4 {
    font-size: 1rem;
  }

  h5 {
    font-size: 0.87055rem;
  }

  h6 {
    font-size: 0.81225rem;
  }

  h1 {
    margin-top: 100px;
  }

  ul, ol {
    margin-left: 1.45rem;
    list-style-position: outside;
    list-style-image: none;
  }

  blockquote {
    margin-left: 1.45rem;
    margin-right: 1.45rem;
    font-size: 1.15rem;
    line-height: 1.45rem;
    border-left: 0.3625rem solid #eee;
    color: hsla(0, 0%, 0%, 0.65);
    padding: 0.5rem 0 0.5rem 1.2rem;
    font-style: italic;
    margin: 2rem 0 2rem 0;
  }

  hr {
    margin-bottom: calc(1.16rem - 1px);
    background: hsla(0, 0%, 0%, 0.2);
    border: none;
    height: 1px;
  }

  b, strong {
    font-weight: 700;
  }

  li {
    margin-bottom: calc(1.16rem / 2);
  }

  ol li, ul li {
    padding-left: 0;
  }

  li > ol {
    margin-left: 1.45rem;
    margin-bottom: calc(1.16rem / 2);
    margin-top: calc(1.16rem / 2);
  }

  li > ul {
    margin-left: 1.45rem;
    margin-bottom: calc(1.16rem / 2);
    margin-top: calc(1.16rem / 2);
  }

  blockquote *:last-child {
    margin-bottom: 0;
  }

  li *:last-child {
    margin-bottom: 0;
  }

  p *:last-child {
    margin-bottom: 0;
  }

  li>p {
    margin-bottom: calc(1.16rem / 2);
  }

  pre, code {
    font-family: 'Source Code Pro', Courier, sans-serif;
    /* This equals to 0.8rem, which works consistently */
    font-size: ${BASE_FONT_SIZE_IN_PX * 0.8}px;
  }

  code {
    background-color: #f4f4f4;
    padding: 2px 6px;
    margin: 0 3px;
    border-radius: 2px;
    white-space: nowrap;
  }

  pre {
    border-radius: 4px;
    line-height: 1.45rem;
    background-color: #fafafa;
    padding: 10px;
    overflow: auto;
  }

  pre > code {
    background: none;
    white-space: pre;
    padding: 0;
    margin: 0;
  }

  code, kbd, samp {
    line-height: 1.5rem;
  }

  abbr {
    border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);
    cursor: help;
  }

  acronym {
    border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);
    cursor: help;
  }

  abbr[title] {
    border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);
    cursor: help;
    text-decoration: none;
  }

  blockquote > :last-child {
    margin-bottom: 0;
  }

  blockquote cite {
    font-size: 1rem;
    line-height: 1.45rem;
    color: hsla(0, 0%, 0%, 0.8);
    font-style: normal;
    font-weight: 400;
  }

  blockquote cite:before {
    content: "— ";
  }

  @media only screen and (max-width:480px) {
    blockquote {
      border-left: 0.18125rem solid #eee;
      padding-left: 0.81562rem;
      font-style: italic;
      margin-left: -1.0875rem;
      margin-right: 0;
    }
  }

  .mermaid {
    margin: 30px 0;
  }
`
